// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__jlXq1","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__SnbGf"};